export const Input = ({ label, error, className = "", ...props }) => (
  <div className={`space-y-2.5 ${className}`}>
    {label && (
      <label className="block text-sm font-semibold text-[#1A1D1A] tracking-wide">
        {label}
      </label>
    )}
    <input
      className={`
        w-full h-[56px] px-5 
        font-sans text-base text-[#1A1D1A]
        bg-white rounded-xl
        border-2 transition-all duration-300
        placeholder:text-[#9A9F9A]
        focus:outline-none focus:border-[#2D4A2A] focus:shadow-[0_0_0_4px_rgba(45,74,42,0.08)]
        ${error ? "border-[#9B4343]" : "border-[#E8E6E1]"}
      `}
      {...props}
    />
    {error && <p className="text-sm text-[#9B4343] mt-1">{error}</p>}
  </div>
);

export const Textarea = ({ label, error, className = "", ...props }) => (
  <div className={`space-y-2.5 ${className}`}>
    {label && (
      <label className="block text-sm font-semibold text-[#1A1D1A] tracking-wide">
        {label}
      </label>
    )}
    <textarea
      className={`
        w-full px-5 py-4
        font-sans text-base text-[#1A1D1A]
        bg-white rounded-xl
        border-2 transition-all duration-300 resize-none
        placeholder:text-[#9A9F9A]
        focus:outline-none focus:border-[#2D4A2A] focus:shadow-[0_0_0_4px_rgba(45,74,42,0.08)]
        ${error ? "border-[#9B4343]" : "border-[#E8E6E1]"}
      `}
      {...props}
    />
    {error && <p className="text-sm text-[#9B4343] mt-1">{error}</p>}
  </div>
);
